import { formatDateShort } from '../../../../lib/dateScripts';
import { objectToArray } from '../../../../lib/script';
import classes from './Box.module.css'

export default function UpcomingTasksBox({summary}) {
    
    
    const tasksByDate = objectToArray(summary.due_next_five_days_by_day);
    return <div className={classes.item} style={{width: 280}}>
        <div className={classes.title}>Due next 5 days</div>
        {tasksByDate.map(({ date, value }) => (
            <div key={date} className={classes.date_item}>
                <div className={classes.date_item_date}>{formatDateShort(date)}</div>
                <div className={classes.date_item_value}>{value}</div>
            </div>
        ))}
    </div>
}